import { Component, Input, OnInit } from '@angular/core';
import { Toast, ToastPackage, ToastrService, IndividualConfig } from 'ngx-toastr';

@Component({
    selector: '[app-custom-toastr]',
    templateUrl: './custom-toastr.component.html',
    styleUrls: ['./custom-toastr.component.scss'],
    standalone: false,
})
export class CustomToastrComponent extends Toast implements OnInit {
    @Input() case: string;
    imgSrc: string;

    constructor(
        public toastPackage: ToastPackage,
        protected toastrService: ToastrService
    ) {
        // the base class ToastBase no longer takes constructor parameters
        // Angular will inject dependencies on the class fields via the generated
        // factory, so we just call super() here.
        super();
    }

    ngOnInit(): void {
        this.selecteTheToastrType();
    }

    /**
     * Signal helper used by the template.  Accessing `options()` directly in
     * the template triggers a type-checker warning about the function always
     * being defined, so we expose the value via a getter.
     */
    get opts(): IndividualConfig<any> {
        return this.options();
    }

    selecteTheToastrType() {
        switch (this.case) {
            case 'success':
                this.imgSrc = '../../../../assets/media/logos/Success-logo.svg';
                break;
            case 'error':
                this.imgSrc = '../../../../assets/media/logos/Error-logo.svg';
                break;
            case 'warning':
            case 'info':
                this.imgSrc = '../../../../assets/media/logos/Warning-logo.svg';

            // here image needs to be updated
            // right now there is no svg icon for info (need this)
            // this.imgSrc = '../../../../assets/media/logos/Warning-logo.svg';
        }
    }
}
